import { BehaviorSubject, Observable } from "rxjs";
import { AccessibilityOptions } from "../models";

class AccessibilityServiceController {
    public currentOptionsSource: BehaviorSubject<AccessibilityOptions> = new BehaviorSubject<AccessibilityOptions>(this.getCurrent());
    public currentOptions: Observable<AccessibilityOptions> = this.currentOptionsSource.asObservable();

    constructor() {
        // this.currentOptions.subscribe(options => {
        //     if (options) {
        //         this.setCurrent(options);
        //     }
        // });
    }

    setAccessibility(enabled: boolean) {
        const newOptions = { ...this.currentOptionsSource.value };
        newOptions.enabled = enabled;
        this.currentOptionsSource.next(newOptions);
        this.setCurrent(newOptions);
        if (enabled) {
            document.body.classList.add('accessibility');
        } else {
            document.body.classList.remove('accessibility');
        }
    }

    getCurrent(): AccessibilityOptions {
        const accessibilityOptions = localStorage.getItem('csb-accessibility');
        if (accessibilityOptions) {
            const options = JSON.parse(accessibilityOptions);
            if (options.enabled) {
                document.body.classList.add('accessibility');
            } else {
                document.body.classList.remove('accessibility');
            }
            
            return options;
        } else {
            return { enabled: false };
        }
    }

    setCurrent(options: AccessibilityOptions) {
        localStorage.setItem('csb-accessibility', JSON.stringify(options));
    }
}

export const AccessibilityService = new AccessibilityServiceController();